/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { QuestionModel } from '../models/question-model';
import { QuestionnaireInstanceModel } from '../models/questionnaire-instance-model';
import {
  questionnaireInstancesInitialisePost,
  QuestionnaireInstancesInitialisePostParams
} from "../fn/questionnaire-instance/questionnaire-instance-initialise-post";
import {
  questionnaireInstanceStartPost,
  QuestionnaireInstanceStartPostParams
} from "../fn/questionnaire-instance/questionnaire-instance-start-post";
import {
  questionnaireInstanceNextPost,
  QuestionnaireInstanceNextPostParams
} from "../fn/questionnaire-instance/questionnaire-instance-next-post";
import {
  questionnaireInstancePreviousPost,
  QuestionnaireInstancePreviousPostParams
} from "../fn/questionnaire-instance/questionnaire-instance-previous-post";
import {
  questionnaireInstanceResumePost,
  QuestionnaireInstanceResumePostParams
} from "../fn/questionnaire-instance/questionnaire-instance-resume-post";
import {
  questionnaireInstanceFinishPost,
  QuestionnaireInstanceFinishPostParams
} from "../fn/questionnaire-instance/questionnaire-instance-finish-post";
import {
  questionnaireInstanceInviteGet,
  QuestionnaireInstanceInviteGetParams
} from "../fn/questionnaire-instance/questionnaire-instance-invite-get";
import {QuestionnaireFinishResponseModel} from "../models/questionnaire-finish-response-model";
import {
  questionnaireInstanceUpdatePatch,
  QuestionnaireInstanceUpdatePatchParams
} from "../fn/questionnaire-instance/questionnaire-instance-update-patch";
import {
  questionnaireInstancesAdminGet,
  QuestionnaireInstancesAdminGetParams,
} from '../fn/questionnaire-instances/questionnaire-instances-admin-get';
import { AdminQuestionnaireInstanceModel } from '../models/admin-questionnaire-instance-model';
import { PaginatedList } from '../models/paginator/paginated-list';

@Injectable({ providedIn: 'root' })
export class QuestionnaireInstanceService extends BaseService {

  questionnaireInstanceGuid?: string;

  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /**
   * Gets all questionnaire instances for admin investigation.
   */
  adminGet$Response(
    params: QuestionnaireInstancesAdminGetParams,
    headers: HttpHeaders,
    context?: HttpContext,
  ): Observable<
    StrictHttpResponse<PaginatedList<AdminQuestionnaireInstanceModel>>
  > {
    return questionnaireInstancesAdminGet(
      this.http,
      this.rootUrl,
      params,
      headers,
      context,
    );
  }

  /**
   * Gets all questionnaire instances for admin investigation.
   */
  adminGet(
    params: QuestionnaireInstancesAdminGetParams,
    headers: HttpHeaders,
    context?: HttpContext,
  ): Observable<PaginatedList<AdminQuestionnaireInstanceModel>> {
    return this.adminGet$Response(params, headers, context).pipe(
      map(
        (
          r: StrictHttpResponse<
            PaginatedList<AdminQuestionnaireInstanceModel>
          >,
        ): PaginatedList<AdminQuestionnaireInstanceModel> => r.body,
      ),
    );
  }

  /** Path part for operation `apiV1QuestionnaireInstancesInviteGet()` */
  static readonly ApiV1QuestionnaireInstanceInviteGetPath = '/api/v1/questionnaire-instances';

  /**
   * Takes a remote invite token as a query parameter, and gets an associated questionnaire instance for the invite link.
   * If the link is public, it will create a new questionnaire instance, otherwise gets the existing questionnaire instance
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inviteGet$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inviteGet$Json$Response(params: QuestionnaireInstanceInviteGetParams, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireInstanceModel>> {
    return questionnaireInstanceInviteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Takes a remote invite token as a query parameter, and gets an associated questionnaire instance for the invite link.
   * If the link is public, it will create a new questionnaire instance, otherwise gets the existing questionnaire instance
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inviteGet$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inviteGet$Json(params: QuestionnaireInstanceInviteGetParams, context?: HttpContext): Observable<QuestionnaireInstanceModel> {
    return this.inviteGet$Json$Response(params, context).pipe(
        map((r: StrictHttpResponse<QuestionnaireInstanceModel>): QuestionnaireInstanceModel => r.body)
    );
  }

  /** Path part for operation `apiV1QuestionnaireInstancesInitialisePost()` */
  static readonly ApiV1QuestionnaireInstancesInitialisePostPath = '/api/v1/questionnaire-instances/initialise';

  /**
   * Initialises a new questionnaire instance, and returns a model representing that instance. The client can then
   * use the /Start API to get the first question, and begin the questionnaire.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1QuestionnaireInstancesInitialisePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  initialisePost$Json$Response(params?: QuestionnaireInstancesInitialisePostParams, headers?: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireInstanceModel>> {
    return questionnaireInstancesInitialisePost(this.http, this.rootUrl, params, headers, context);
  }

  /**
   * Initialises a new questionnaire instance, and returns a model representing that instance. The client can then
   * use the /Start API to get the first question, and begin the questionnaire.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1QuestionnaireInstancesInitialisePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  initialisePost$Json(params?: QuestionnaireInstancesInitialisePostParams, headers?: HttpHeaders, context?: HttpContext): Observable<QuestionnaireInstanceModel> {
    return this.initialisePost$Json$Response(params, headers, context).pipe(
      map((r: StrictHttpResponse<QuestionnaireInstanceModel>): QuestionnaireInstanceModel => r.body)
    );
  }

  /** Path part for operation `apiV1QuestionnaireInstancesQuestionnaireInstanceGuidStartPost()` */
  static readonly ApiV1QuestionnaireInstancesQuestionnaireInstanceGuidStartPostPath = '/api/v1/questionnaire-instances/{questionnaireInstanceGuid}/start';

  /**
   * Starts an initialised questionnaire instance, getting the first question which should be presented to the user,
   * and updating the status of the questionnaire.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1QuestionnaireInstancesQuestionnaireInstanceGuidStartPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  startPost$Json$Response(params: QuestionnaireInstanceStartPostParams, context?: HttpContext): Observable<StrictHttpResponse<QuestionModel>> {
    return questionnaireInstanceStartPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts an initialised questionnaire instance, getting the first question which should be presented to the user,
   * and updating the status of the questionnaire.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1QuestionnaireInstancesQuestionnaireInstanceGuidStartPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  startPost$Json(params: QuestionnaireInstanceStartPostParams, context?: HttpContext): Observable<QuestionModel> {
    return this.startPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<QuestionModel>): QuestionModel => r.body)
    );
  }

  /** Path part for operation `apiV1QuestionnaireInstancesQuestionnaireInstanceGuidQuestionsNextPost()` */
  static readonly ApiV1QuestionnaireInstancesQuestionnaireInstanceGuidQuestionsNextPostPath = '/api/v1/questionnaire-instances/{questionnaireInstanceGuid}/questions/next';

  /**
   * For a given questionnaire instance, gets the next question in the sequence based on the answer to the previous
   * question, and returns a QuestionModel representing that question. Returns a 200 OK response with question data
   * if there is a next question, otherwise returns a 204 NoContent response if there is no next question.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1QuestionnaireInstancesQuestionnaireInstanceGuidQuestionsNextPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  nextPost$Json$Response(params: QuestionnaireInstanceNextPostParams, context?: HttpContext): Observable<StrictHttpResponse<QuestionModel>> {
    return questionnaireInstanceNextPost(this.http, this.rootUrl, params, context);
  }

  /**
   * For a given questionnaire instance, gets the next question in the sequence based on the answer to the previous
   * question, and returns a QuestionModel representing that question. Returns a 200 OK response with question data
   * if there is a next question, otherwise returns a 204 NoContent response if there is no next question.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1QuestionnaireInstancesQuestionnaireInstanceGuidQuestionsNextPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  nextPost$Json(params: QuestionnaireInstanceNextPostParams, context?: HttpContext): Observable<QuestionModel> {
    return this.nextPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<QuestionModel>): QuestionModel => r.body)
    );
  }

  /** Path part for operation `apiV1QuestionnaireInstancesQuestionnaireInstanceGuidQuestionsPreviousPost()` */
  static readonly ApiV1QuestionnaireInstancesQuestionnaireInstanceGuidQuestionsPreviousPostPath = '/api/v1/questionnaire-instances/{questionnaireInstanceGuid}/questions/previous';

  /**
   * Gets the previous question in the logical sequence, including any answer data which is present for the
   * questionnaire instance. Returns a 200 OK response with question data if there is a previous question, otherwise
   * returns a 204 NoContent response if there is no previous question.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1QuestionnaireInstancesQuestionnaireInstanceGuidQuestionsPreviousPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  previousPost$Json$Response(params: QuestionnaireInstancePreviousPostParams, context?: HttpContext): Observable<StrictHttpResponse<QuestionModel>> {
    return questionnaireInstancePreviousPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the previous question in the logical sequence, including any answer data which is present for the
   * questionnaire instance. Returns a 200 OK response with question data if there is a previous question, otherwise
   * returns a 204 NoContent response if there is no previous question.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1QuestionnaireInstancesQuestionnaireInstanceGuidQuestionsPreviousPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  previousPost$Json(params: QuestionnaireInstancePreviousPostParams, context?: HttpContext): Observable<QuestionModel> {
    return this.previousPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<QuestionModel>): QuestionModel => r.body)
    );
  }

  /** Path part for operation `apiV1QuestionnaireInstancesQuestionnaireInstanceGuidResumePost()` */
  static readonly ApiV1QuestionnaireInstancesQuestionnaireInstanceGuidResumePostPath = '/api/v1/questionnaire-instances/{questionnaireInstanceGuid}/resume';

  /**
   * Resumes a questionnaire instance, updating the status and returning a model representing the question
   * which is next in the logical sequence for the user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1QuestionnaireInstancesQuestionnaireInstanceGuidResumePost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  resumePost$Json$Response(params: QuestionnaireInstanceResumePostParams, context?: HttpContext): Observable<StrictHttpResponse<QuestionModel>> {
    return questionnaireInstanceResumePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Resumes a questionnaire instance, updating the status and returning a model representing the question
   * which is next in the logical sequence for the user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1QuestionnaireInstancesQuestionnaireInstanceGuidResumePost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resumePost$Json(params: QuestionnaireInstanceResumePostParams, context?: HttpContext): Observable<QuestionModel> {
    return this.resumePost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<QuestionModel>): QuestionModel => r.body)
    );
  }

  /** Path part for operation `apiV1QuestionnaireInstancesQuestionnaireInstanceGuidFinishPost()` */
  static readonly ApiV1QuestionnaireInstancesQuestionnaireInstanceGuidFinishPostPath = '/api/v1/questionnaire-instances/{questionnaireInstanceGuid}/finish';

  /**
   * Finishes the questionnaire, updating the status based on the finishedEarly property, which indicates whether
   * or not the user finished before completing all questions.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1QuestionnaireInstancesQuestionnaireInstanceGuidFinishPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  finishPost$Response(params: QuestionnaireInstanceFinishPostParams, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireFinishResponseModel>> {
    return questionnaireInstanceFinishPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Finishes the questionnaire, updating the status based on the finishedEarly property, which indicates whether
   * or not the user finished before completing all questions.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1QuestionnaireInstancesQuestionnaireInstanceGuidFinishPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  finishPost(params: QuestionnaireInstanceFinishPostParams, context?: HttpContext): Observable<QuestionnaireFinishResponseModel> {
    return this.finishPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<QuestionnaireFinishResponseModel>): QuestionnaireFinishResponseModel => r.body)
    );
  }

  /**
   * Updates a questionnaire instance
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   *
   * This method doesn't expect any request body.
   */
  updatePatch$Response(params: QuestionnaireInstanceUpdatePatchParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return questionnaireInstanceUpdatePatch(this.http, this.rootUrl, headers, params, context);
  }
}
